"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.AutoRowSize = void 0;
var _autoRowSize = require("./autoRowSize");
exports.PLUGIN_KEY = _autoRowSize.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _autoRowSize.PLUGIN_PRIORITY;
exports.AutoRowSize = _autoRowSize.AutoRowSize;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/autoRowSize/index.js
// module id = 1233
// module chunks = 0